export default () => {
  /////////////////////////////
  ////////// DESKTOP //////////
  /////////////////////////////
  function setWindowSize(){
    var wnidowinnerwidth = window.innerWidth;
    if(wnidowinnerwidth > 1350){
      console.log(wnidowinnerwidth);

      let triggers = document.querySelectorAll(".desktop-nav .main-nav .menu a.trigger");
      let triggersnew = document.querySelectorAll("header .nav-container.desktop-nav .main-nav .menu > li > a");
      let nav_screens = document.querySelectorAll(".desktop .nav-screen");
      /*let blur_overlay = document.querySelector("#blur-overlay");*/
      let search_input_desktop = document.querySelector(".search_input.desktop");
      jQuery(document).on("click", function(a) {
        console.log(a.target);
        var container = jQuery("header .nav-container .main-nav .menu");
        if(!container.is(a.target) && container.has(a.target).length === 0){
          jQuery(".nav-screen").removeClass("open");
          jQuery("header .nav-container .main-nav .menu > li a").removeClass("open");
          jQuery("header .nav-container .main-nav .menu > li a").attr("aria-expanded", "false");
          /*blur_overlay.classList.remove("open");*/
        }
      });
      for (let i = 0; i < triggers.length; i++) {
        triggers[i].addEventListener("click", function (e) {
          e.preventDefault();
          let headerelement = document.querySelector("header.site-header");
          let targetIndex = triggers[i].dataset.navTarget;
          let element = document.querySelector(".desktop #nav_screen_" + targetIndex);
          if(targetIndex){
            /*
            let closer = element.querySelector(".close-screen-js");
            closer.addEventListener("click", function (e) {
              e.preventDefault();
              let screen = document.querySelector(
                ".desktop #nav_screen_" + targetIndex
              );
              screen.classList.remove("open");
              triggers[i].ariaExpanded = false;
              /*blur_overlay.classList.remove("open");*/
              /*triggers[i].classList.remove("open");
              triggers[i].focus();
            });
            */
            for (let j = 0; j < nav_screens.length; j++) {
              if (nav_screens[j] != element) {
                nav_screens[j].classList.remove("open");
                triggers[j].ariaExpanded = false;
              }
            }
            for (let m = 0; m < triggersnew.length; m++) {
              if(i == m){}
              else{
                triggersnew[m].classList.remove("open");
              }
            }
            triggers[i].classList.toggle("open");
            triggers[i].ariaToggle("aria-expanded");
            element.classList.toggle("open");
            headerelement.classList.toggle("opened_nav_screen");
            search_input_desktop.classList.remove("open");
            /*
            if (element.classList.contains("open")) {
              blur_overlay.classList.add("open");
            } else {
              blur_overlay.classList.remove("open");
            }
            */
          }else{
            var trgetnew = triggers[i].href;
            location.href = trgetnew;
          }
        });
      }

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" || event.key === 27) {
          //if esc key was not pressed in combination with ctrl or alt or shift
          const isNotCombinedKey = !(
            event.ctrlKey ||
            event.altKey ||
            event.shiftKey
          );
          for (let i = 0; i < nav_screens.length; i++) {
            if (nav_screens[i].matches(":focus-within") && isNotCombinedKey) {
              nav_screens[i].classList.remove("open");
              triggers[i].ariaExpanded = false;
              /*blur_overlay.classList.remove("open");*/
              triggers[i].classList.remove("open");
              triggers[i].focus();
            }
          }
        }
      });
    }
    else{
      console.log('mobile');
      /////////////////////////////
      ////////// MOBILE ///////////
      /////////////////////////////
      let mobile_triggers = document.querySelectorAll(
        ".mobile-menu .mobile.top-level a.trigger"
      );
      let mobile_nav_screens = document.querySelectorAll(
        ".mobile-menu .nav-screen"
      );
      let mobile_closers = document.querySelectorAll(".mobile-menu a.close-this");

      for (let i = 0; i < mobile_closers.length; i++) {
        mobile_closers[i].addEventListener("click", function (e) {
          e.preventDefault();
          mobile_closers[i].parentNode.classList.remove("open");
        });
      }

      for (let i = 0; i < mobile_triggers.length; i++) {
        mobile_triggers[i].addEventListener("click", function (e) {
          e.preventDefault();

          let targetIndex = mobile_triggers[i].dataset.navTarget;
          if(targetIndex){
            let element = document.querySelector(
              ".mobile #nav_screen_" + targetIndex
            );

            for (let j = 0; j < mobile_nav_screens.length; j++) {
              if (mobile_nav_screens[j] != element) {
                mobile_nav_screens[j].classList.remove("open");
              }
            }

            element.classList.toggle("open");
          }else{
            var trgetnew = mobile_triggers[i].href;
            location.href = trgetnew;
          }
        });
      }

      // MOBILE MENU TOGGLE
      let open = document.querySelector(".open-menu-js");
      let close = document.querySelector(".close-menu-js");
      let mobileMenu = document.querySelector(".mobile-menu");

      open.addEventListener("click", function (e) {
        mobileMenu.classList.add("open");
      });

      close.addEventListener("click", function (e) {
        mobileMenu.classList.remove("open");
      });
    }
  }
  window.onload = setWindowSize;
};